import { IncomingHttpHeaders } from 'http';

/**
 * Provides the shopping channel (web vs app) based on the headers.
 *
 * @param headers headers for the current request.
 * @return a string representing the shopping channel.
 */
export function getChannelTypeFromHeader(headers: IncomingHttpHeaders): string {
  return getChannelType(headers?.['user-agent'] as string);
}

/**
 * Provides the shopping channel (web vs app) based on the user agent.
 *
 * @param userAgent User Agent
 * @return a string representing the shopping channel.
 */
export function getChannelType(userAgent?: string): string {
  // indexOf is 10x faster than startsWith https://www.measurethat.net/Benchmarks/Show/4797/1/js-regex-vs-startswith-vs-indexof
  if (userAgent?.indexOf('chewy-android') === 0) {
    return 'chewy-android';
  } else if (userAgent?.indexOf('chewy-ios') === 0) {
    return 'chewy-ios';
  } else if (userAgent?.indexOf('ChewyAutoship') === 0) {
    return 'ChewyAutoship';
  } else {
    // TODO: add desktop, mobile, tablet channels
    return 'web';
  }
}

/**
 * determines if the shopping channel is web or app based on user agent.
 *
 * @param userAgent User Agent
 * @returns boolean
 */
export function isChannelMobileApp(userAgent?: string): boolean {
  if (!userAgent) {
    return false;
  }
  // indexOf is 10x faster than regex https://www.measurethat.net/Benchmarks/Show/4797/1/js-regex-vs-startswith-vs-indexof
  return userAgent?.indexOf('chewy-android') === 0 || userAgent?.indexOf('chewy-ios') === 0;
}
